import { useEffect } from 'react';
import { create } from 'zustand';

interface PageState {
  title: string;
  subtitle: string;
  set(title: string, subtitle?: string): void;
}

export const usePageStore = create<PageState>((set) => ({
  title: '',
  subtitle: '',
  set: (title, subtitle = '') => set({ title, subtitle }),
}));

/**
 * Hook ergonómico para usar dentro de una página:
 *
 *   usePageTitle('Dashboard', 'Resumen operativo · 22 de abril de 2026');
 *
 * Sincroniza título/subtítulo del topbar al montar y limpia al desmontar.
 */
export function usePageTitle(title: string, subtitle = ''): void {
  const setTitle = usePageStore((s) => s.set);
  useEffect(() => {
    setTitle(title, subtitle);
  }, [title, subtitle, setTitle]);
}
